import React from 'react'
import './Footer.css'

export default function Footer() {
  const year = new Date().getFullYear()
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-left">
          <span className="footer-logo">
            <span className="footer-logo-bracket">[</span>QO<span className="footer-logo-bracket">]</span>
          </span>
          <span className="footer-copy">
            © {year} Quentin Ott — Tous droits réservés
          </span>
        </div>

        <div className="footer-links">
          <span className="footer-built">Construit avec React · Three.js · ♥</span>
        </div>

        <button className="footer-scroll-top" onClick={scrollTop} aria-label="Retour en haut">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 11l5-6 5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
          Haut
        </button>
      </div>
    </footer>
  )
}
